<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :large="large" :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">Evidência</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Nome"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <!-- <app-city-task-combobox
              :filter="payload"
              v-if="!filter.municipioTarefa.municipioTarefaId"
            ></app-city-task-combobox> -->

            <v-text-field
              v-model="municipioTarefa.municipioTarefa.nome"
              v-if="municipioTarefa.municipioTarefa.municipioTarefaId"
              :label="`${isAT ? 'Atividade' : 'Tarefa'}`"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Descrição"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityEvidenceAPI } from "@/modules/city/API/CityEvidenceAPI";
import { AppCityTaskCombobox } from "@/modules/task";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalInsertEvidence",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    filter: { type: Object, required: false },
    municipioTarefaP: {
      type: Object,
      required: false,
      default: () => ({ municipioTarefa: { municipioTarefa: {} } }),
    },
  },
  components: {
    AppCityTaskCombobox,
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isAT"]),
  },
  data() {
    return {
      payload: {
        municipioId: this.$route.params.id,
        municipioTarefa: {},
      },
      dialog: false,
      municipioTarefa: {
        municipioTarefa: {},
      },
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    close() {
      if (this.edit !== true) {
        (this.payload = {
          municipioId: this.$route.params.id,
          municipioTarefa: {},
        }),
          (this.municipioTarefa.municipioTarefa =
            this.municipioTarefaP.municipioTarefa);
      } else {
        this.payload = { ...this.object };
        this.municipioTarefa.municipioTarefa = this.object.municipioTarefa;
      }
      this.dialog = false;
    },
    onConfirm() {
      this.setLoading(true);
      if (!this.municipioTarefa.municipioTarefa.municipioTarefaId) {
        this.$notification.error(
          `O preenchimento de uma ${
            this.isAT ? "iniciativa" : "tarefa"
          } é obrigatório.`
        );
      } else {
        const valores = {
          ...this.payload,
          municipioTarefaId:
            this.municipioTarefa.municipioTarefa.municipioTarefaId,
          municipioTarefa: null,
        };
        if (this.edit === true) {
          cityEvidenceAPI
            .update(valores)
            .then((resp) => {
              this.dialog = false;
              this.payload = { ...this.object };
              this.setLoading(false);
              this.$emit("onSave");
            })
            .catch();
        } else {
          cityEvidenceAPI
            .create(valores)
            .then((resp) => {
              this.dialog = false;
              this.payload = {
                municipioId: this.$route.params.id,
                municipioTarefa: {},
              };
              this.setLoading(false);
              this.$emit("onSave");
            })
            .catch();
        }
      }
    },
  },
  mounted() {
    this.municipioTarefa.municipioTarefa = this.filter.municipioTarefa;
  },
  watch: {
    dialog(val) {
      if (val) {
        if (this.object && this.edit === true) {
          this.payload = { ...this.object };
          this.municipioTarefa.municipioTarefa = this.payload.municipioTarefa;
          this.loadfirst = true;
        }
      }
    },
    "filter.municipioTarefa"(newValue, oldValue) {
      if (newValue) {
        this.municipioTarefa.municipioTarefa = newValue;
      }
    },
    object(newValue, oldValue) {
      this.payload = newValue;
    },
  },
};
</script>
